export default {
    BASE_URL: '/company/pms/send/work',
    api: [
        {
            name: 'projectList',
            desc: '获取项目列表列表',
            method: 'GET',
            path: '/proj/list'
        },
        {
            name: 'pworkList',
            desc: '获取派工单列表',
            method: 'GET',
            path: '/list'
        },
        {
            name: 'pworkListDetail',
            desc: '获取派工单详情',
            method: 'GET',
            path: '/detail'
        },
        {
            name: 'teamListDetail',
            desc: '获取班组记工列表',
            method: 'GET',
            path: '/record/list'
        },
        {
            name: 'teamList',
            desc: '承包单位列表',
            method: 'GET',
            path: '/team/list'
        },
        {
            name: 'submit',
            desc: '新增派工单提交',
            method: 'POST',
            path: '/insert'
        },
        {
            name: 'delete',
            desc: '删除派工单',
            method: 'DELETE',
            path: '/delete'
        },
        {
            name: 'update',
            desc: '修改派工单状态',
            method: 'PUT',
            path: '/update/status'
        },
        {
            name: 'reName',
            desc: '派工单号唯一校验',
            method: 'GET',
            path: '/code/check'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/project/pwork.js